import type { DevelopmentMapPayload } from '@/types/development-map'
import { createQuery } from '../api/query'

export const keyDeliverableContinuation = (arg: string) => ['deliverableContinuation', arg]

export const useQueryDeliverableContinuationContext = createQuery<any>({
    key: keyDeliverableContinuation,
    url: '/campaigns/deliverables/:deliverableId/continuation',
})

export const keyRecentLivingBriefs = () => ['recentLivingBriefs']

export const useQueryRecentLivingBriefs = createQuery<any>({
    key: keyRecentLivingBriefs,
    url: '/campaigns/living-briefs/recent',
})

export const keyDevelopmentMap = () => ['mobileConsumerDevelopmentMap']

export const useQueryDevelopmentMap = createQuery<{ data: DevelopmentMapPayload }>({
    key: keyDevelopmentMap,
    url: '/campaigns/mobile-consumer/development-map',
})
